import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import 'assets/styles/main.scss';
import 'assets/styles/tailwindcss/index.css';
import * as serviceWorker from 'serviceWorker';
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom';
import moment from 'moment-timezone';
import { registerLocale } from 'react-datepicker';
import vi from 'date-fns/locale/vi';
import { store } from './store';
import Navbar from './components/Navbar';
import { routes } from './router/routes';
import { Providers } from './layouts/providers';

function App() {
    useEffect(() => {
        registerLocale('vi', vi);
        moment.tz.setDefault('Asia/Saigon');
        moment.updateLocale('en', {
            weekdays : [
                "Chủ nhật", "Thứ 2", "Thứ 3", "Thứ 4", "Thứ 5", "Thứ 6", "Thứ 7"
            ]
        });
    }, []);
    return (
        <React.StrictMode>
            <Providers session={store}>
                <Router>
                    <div className="flex">
                        <Navbar />
                        <main className="flex-1 lg:ml-64 p-4 lg:p-8 min-h-screen mt-2">
                            <Switch>
                                {routes.map((r, i) => (
                                    // @ts-ignore
                                    <Route key={i} path={r.path} component={r.component} exact={r.exact} />
                                ))}
                                <Redirect to="/auth" />
                            </Switch>
                        </main>
                    </div>
                </Router>
                {/*<Router>*/}
                {/*    <Switch>*/}
                {/*        {routes.map((r, i) => (*/}
                {/*            <Route key={i} path={r.path} component={r.component} exact={r.exact} />*/}
                {/*        ))}*/}
                {/*        <Redirect to="/auth" />*/}
                {/*    </Switch>*/}
                {/*    /!*{renderRoutes(routes)}</Router>*!/*/}
                {/*</Router>*/}
            </Providers>
        </React.StrictMode>
    );
}

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
